import { useEffect, useState } from 'react';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const whatsappNumber = '5511919566435';
  const whatsappMessage = encodeURIComponent('Olá! Sou dono de uma incorporadora e gostaria de saber mais sobre captação de investimentos através de clubes de investimento.');

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg py-4' : 'bg-transparent py-6'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between">
          <img 
            alt="Swiss Capital" 
            className={`h-14 sm:h-16 w-auto transition-all duration-300 ${scrolled ? '' : 'brightness-0 invert'}`}
            src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/1d5347e5b4a8826256140ba3ce502ab6.png"
          />
          <a
            href={`https://api.whatsapp.com/send/?phone=${whatsappNumber}&text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl w-5 h-5 flex items-center justify-center"></i>
            <span className="hidden sm:inline">Falar Agora</span>
          </a>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/a00786099d5775688b84b553f12b8167.jpg" 
            alt="Mercado imobiliário - Prédios modernos" 
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-20 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-6">
            Capte Investidores para Sua Incorporadora
          </h1>
          
          <p className="text-xl sm:text-2xl lg:text-3xl text-white/95 mb-8 max-w-4xl mx-auto leading-relaxed">
            Assessoria especializada em preparar construtoras para captar investidores através de <strong>clubes de investimento</strong> e <strong>fundos imobiliários</strong> para incorporadoras que buscam crescimento
          </p>

          <div className="grid sm:grid-cols-3 gap-6 mb-12 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">R$ 115 Bi</div>
              <div className="text-white/90 text-sm">Em VGV na Plataforma</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">423</div>
              <div className="text-white/90 text-sm">Incorporadoras Parceiras</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">R$ 90 Mi</div>
              <div className="text-white/90 text-sm">Captados para Clientes</div>
            </div>
          </div>

          <a
            href={`https://api.whatsapp.com/send/?phone=${whatsappNumber}&text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-10 py-5 rounded-xl text-xl font-bold transition-all duration-300 hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer mb-4"
          >
            <i className="ri-whatsapp-line text-3xl w-7 h-7 flex items-center justify-center"></i>
            Agendar Conversa Agora
          </a>
          
          <p className="text-white/80 text-sm">
            <i className="ri-shield-check-line mr-1"></i>
            Atendimento personalizado • Sem compromisso
          </p>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
        </div>
      </section>

      {/* Benefícios Section */}
      <section className="py-20 bg-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-red-50 rounded-full blur-3xl opacity-30"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Por Que Escolher a Swiss Capital?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Somos especialistas em conectar incorporadoras com investidores qualificados
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-group-line text-3xl text-red-600 w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Clubes de Investimento Private Equity</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Estruturamos clubes de investimento personalizados que conectam investidores qualificados diretamente com seu empreendimento.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Investimento direto em empreendimentos
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Retornos atrativos e transparentes
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Acompanhamento integral
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-funds-line text-3xl text-red-600 w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Originação para Fundos de Investimento</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Conectamos sua incorporadora com fundos de investimento em CRI, CRA e tokenização imobiliária.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Operações CRI e CRA especializadas
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Antecipação de recebíveis
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Tokenização de ativos imobiliários
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-rocket-line text-3xl text-red-600 w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Assessoria Completa</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Oferecemos suporte integral desde a análise de viabilidade até a captação efetiva dos recursos.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Marketing especializado
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Suporte jurídico completo
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Plataforma tecnológica Credit Pro
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Como Funciona */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Como Funciona Nossa Assessoria
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Processo simples e eficiente em 4 etapas
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-red-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-6 shadow-lg">
                1
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Primeiro Contato</h3>
              <p className="text-gray-600">
                Entre em contato via WhatsApp e converse com nossa equipe especializada
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-red-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-6 shadow-lg">
                2
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Análise Gratuita</h3>
              <p className="text-gray-600">
                Realizamos pré-diagnóstico do seu empreendimento sem custo
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-red-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-6 shadow-lg">
                3
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Estruturação</h3>
              <p className="text-gray-600">
                Desenvolvemos a estratégia ideal de captação para seu projeto
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-red-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-6 shadow-lg">
                4
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Captação</h3>
              <p className="text-gray-600">
                Conectamos investidores qualificados com seu empreendimento
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Depoimento */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              O Que Nossos Clientes Dizem
            </h2>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 sm:p-12 shadow-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <i className="ri-double-quotes-l text-5xl text-red-600 mr-4"></i>
            </div>
            <blockquote className="text-xl text-gray-800 leading-relaxed mb-8 italic">
              "Antes de conhecer a Swiss Capital, nossa maior dificuldade era encontrar investidores qualificados para os projetos. Em poucos meses, eles não só estruturaram a captação como trouxeram parceiros estratégicos. Hoje a Minerale se posiciona de forma muito mais sólida no mercado."
            </blockquote>
            <div className="flex items-center">
              <img 
                alt="Marcos Castilho" 
                className="w-16 h-16 rounded-full object-cover mr-4"
                src="https://public.readdy.ai/ai/img_res/498a6c0effce01b1ba31f206147f9bd3.jpg"
              />
              <div>
                <div className="font-bold text-gray-900 text-lg">Marcos Castilho</div>
                <div className="text-gray-600">Minerale Construtora</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img 
            src="https://public.readdy.ai/ai/img_res/196a7327e2a5e14563eec1a9a69ca123.jpg" 
            alt="Swiss precision background" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Pronto Para Captar Investidores?
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Agende uma conversa com nossa equipe e descubra como podemos ajudar sua incorporadora a captar recursos através de clubes de investimento e fundos imobiliários
          </p>

          <a
            href={`https://api.whatsapp.com/send/?phone=${whatsappNumber}&text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-12 py-6 rounded-xl text-2xl font-bold transition-all duration-300 hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer mb-6"
          >
            <i className="ri-whatsapp-line text-4xl w-8 h-8 flex items-center justify-center"></i>
            Falar com Especialista Agora
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/80 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              Resposta em minutos
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line"></i>
              Análise gratuita
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-user-star-line"></i>
              Atendimento personalizado
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-center mb-8">
            <div className="text-center">
              <img 
                alt="Swiss Capital" 
                className="h-12 w-auto brightness-0 invert opacity-80 mb-4 mx-auto"
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/1d5347e5b4a8826256140ba3ce502ab6.png"
              />
              <p className="text-gray-400 text-sm">
                Assessoria especializada em captação de investimentos para incorporadoras
              </p>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center">
            <div className="text-gray-400 text-sm">
              © 2025 Swiss Capital - Todos os direitos reservados
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://api.whatsapp.com/send/?phone=${whatsappNumber}&text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-600 hover:bg-green-700 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-110 z-50 cursor-pointer animate-pulse"
        aria-label="Falar no WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
      </a>
    </div>
  );
}
